import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MyQuotesService } from 'src/app/services/feature/myQuotes/my-quotes.service';
import { QuotePopupComponent } from '../../kb-Get-A-Quote/kb-get-aquote/quote-popup/quote-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { KbGetAQuoteService } from '../../kb-Get-A-Quote/kb-get-aquote/kb-get-aquote.service';
import { GlobalMessageService, GlobalMessageType, TranslationService } from '@spartacus/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-my-quotes-details',
  templateUrl: './my-quotes-details.component.html',
  styleUrls: ['./my-quotes-details.component.scss'],
  standalone: false
})
export class MyQuotesDetailsComponent {
  quoteDetails: any;
  isCancelAllowed = false;
  isSubmitAllowed = false;

  private subscription = new Subscription();
  private service = inject(KbGetAQuoteService);
  private matDialog = inject(MatDialog);
  constructor(private myQuotesService: MyQuotesService,
    private route: ActivatedRoute, private cdr: ChangeDetectorRef, private translationService: TranslationService,
    private globalMessageService: GlobalMessageService, private router: Router) {

  }

  ngOnInit() {
    this.getQuoteDetails();
  }

  getQuoteDetails() {
    this.subscription.add(this.route.params.subscribe((data: any) => {
      if (data.quoteId) {
        this.subscription.add(this.myQuotesService.getQuoteDetails(data.quoteId)
          .subscribe(data => {
            this.quoteDetails = data;
            this.isCancelAllowed = this.quoteDetails.allowedActions.filter(item => item.key === 'CANCEL').length > 0;
            this.isSubmitAllowed = this.quoteDetails.allowedActions.filter(item => item.key === 'SUBMIT').length > 0;
            this.cdr.detectChanges();
          }))
      }
    }))
  }

  formatDate(dateString: string, format?: string): string {
    const date = new Date(dateString);

    const day = this.padZero(date.getDate());
    const month = this.padZero(date.getMonth() + 1);
    const year = date.getFullYear();
    if (format) {
      return `${year}${month}${day}`
    }

    return `${day}.${month}.${year}`;
  }

  padZero(value: number): string {
    return value < 10 ? '0' + value : value.toString();
  }

  deleteEntries(item) {
    this.subscription.add(this.myQuotesService.deleteEntries(this.quoteDetails.code, item.entryNumber).subscribe((data: any) => {
      if (data.status === 'SUCCESS') {
        let message = ''
        this.subscription.add(this.translationService.translate(data?.['message']).subscribe((key) => {
          message = key;
        }));
        this.globalMessageService.add(message, GlobalMessageType.MSG_TYPE_INFO);
        this.getQuoteDetails();
      }
    }))
  }

  openDialogBox(isSubmit: boolean) {
    const data = {
      description: this.quoteDetails.description,
      id: this.quoteDetails.code,
      calledBy: '',
      name: this.quoteDetails.name,
      source: 'side-panel'
    };

    if (isSubmit) {
      data.calledBy = 'SUBMIT';
    } else {
      data.calledBy = 'CANCEL';
    }
    this.service.popUpCaller = data;
    const dialogRef = this.matDialog.open(QuotePopupComponent, { maxWidth: '440px', });
    this.subscription.add(dialogRef.afterClosed().subscribe((res: any) => {

      if (res) {
        if (res.type === 'submit') {
          let msgkey = '';
          this.subscription.add(this.translationService.translate(res?.message).subscribe((key) => {
            msgkey = key;
          }));
          this.myQuotesService.cancelQuoteMsg.next(msgkey);
          this.router.navigate(['my-quotes'])
        } else {
          let msgkey = '';
          this.subscription.add(this.translationService.translate(res?.['message'].message).subscribe((key) => {
            if (key.includes('{0}')) {
              msgkey = key.replace('{0}', res.errorValue1);
            }
          }));
          this.myQuotesService.cancelQuoteMsg.next(msgkey);
          this.router.navigate(['my-quotes'])
        }
      }
    }))
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}

